import * as React from "react";
import {Paper, Button, Stack, Typography} from "@mui/material";
import {styled} from "@mui/material/styles";
import axios from "../../axios";
import {removeHtml, truncateStr} from "../Service";

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: '464px',
    height: 'auto',
    borderRadius: '5px'
});

const AdviceDynamic = ({child}) => {
    return (
            <Stack
                direction="column"
                justifyContent="left"
                alignItems="flex-start"
                spacing={2}
                sx={{paddingTop:'30px'}}
            >
                <Stack
                    direction={child.type === "RIGHT_PICTURE" ? "row-reverse" : "row"}
                    justifyContent="left"
                    alignItems="flex-start"
                    spacing={2}
                >
                    <Img
                        alt={child.image.alternativeText}
                        src={`${axios.defaults.apiBaseURL}/${child.image.uri}`}
                        role="img"
                    />
                    <Stack
                        direction="column"
                        justifyContent="left"
                        alignItems="flex-start"
                        spacing={3}
                    >
                        <Typography variant="h3" sx={{color:'#DD809D'}}>
                            {child.title.text}
                        </Typography>
                        <Typography
                            variant={'subtitle3'}
                            sx={{color:'#263238',marginLeft:'2px !important'}}
                        >
                            {truncateStr(removeHtml(child.text.text), 300)}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
    )
}

export default AdviceDynamic;
